module.exports = __webpack_public_path__ + "static/img/16.8db8969.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/16.png
// module id = IE/Z
// module chunks = 6